import ApiService from "@/api/ApiService";

export const OneCareService = {
  baseURL: process.env.VUE_APP_ONECARE_API_URL,
  getPatients(limit = 10) {
    return new Promise(async (resolve, reject) => {
      let params = {
        roleCategoryId: 0,
        details: false,
        pageSize: limit
      }
      ApiService.get(`${this.baseURL}`, 'persons', {params})
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  getPatient(personId) {
    let params = {
      details: true
    }
    return new Promise(async (resolve, reject) => {
      ApiService.get(`${this.baseURL}`, `persons/${personId}`, {params})
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  postPatient(patient) {
    return new Promise(async (resolve, reject) => {
      ApiService.post(`${this.baseURL}/persons`, patient)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  deletePatient(personId) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/persons/${personId}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  changePatientStatus(personId) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/persons/${personId}/inactivation/toogle`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  getPatientMeasurements(personId, measurementTypeId, metadata = true) {
    let params = {
      personId: personId,
      desc: true,
      measGroupId: measurementTypeId,
      metadata: metadata
    }
    return new Promise(async (resolve, reject) => {
      ApiService.get(`${this.baseURL}`, 'measurements', {params})
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  sendPdfByEmail(personId, patientEmail) {
    return new Promise(async (resolve, reject) => {
      let params = {
        personId: [personId]
      }
      ApiService.post(`${this.baseURL}/patients/report/email?email=true&outgoing_mail=${patientEmail}&downalod=false&byEvollu=true`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  downloadReportPdf(personId) {
    return new Promise(async (resolve, reject) => {
      let params = {
        personId: [personId]
      }
      ApiService.post(`${this.baseURL}/patients/report/email?email=true&byEvollu=true&download=true`, params, {responseType: 'blob'})
        .then(response => resolve(response))
        .catch(errors => reject(errors))
    })
  },
  getGraphs(orgId, startDate, endDate) {
    return new Promise((resolve, reject) => {
      let params = {
        facilityId_evollu: orgId,
        start: startDate,
        end: endDate
      }
      ApiService.get(`${this.baseURL}`, 'metrics/evollu_platform/dashboard/graphs', {params})
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  getPatientsFromResultTypeId(resultTypeId, facilityId, startDate, endDate, page, pageSize) {
    return new Promise((resolve, reject) => {
      let params = {
        facilityId_evollu: facilityId,
        chart_result: resultTypeId,
        start: startDate,
        end: endDate,
        page: page,
        pageSize: pageSize
      }
      ApiService.get(`${this.baseURL}`, 'metrics/evollu_platform/dashboard/persons', {params})
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  deleteMeasurement(measurementId) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/measurements/${measurementId}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getDistricts() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}`, `events/local/districts`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  getCounties(districtId) {
    if (districtId === null) {
      return []
    }
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}`, `events/local/municip/${districtId}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  downloadChartPatientsExcel(params) {
    return ApiService.blob(`${this.baseURL}/metrics/evollu_platform/dashboard/persons/export`, params)
  },

  deleteLimitRule(personId, ruleId) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/persons/${personId}/limitRules/${ruleId}`)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err))
    })
  },

  getLimitRulesOptions() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/measurements/limitrule/mgroup/chart_results`)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err))
    })
  },

  establishRelationBetweenCaregiverAndPerson(userId, personId) {
    let data = {
      caregiverPersonIds: [userId],
      patientPersonIds: [personId]
    }
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/caregiverPerson`, data)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err))
    })
  },

  createLimitRule(personId, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/persons/${personId}/limitRules`, data)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err))
    })
  },

  postMeasurements(data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/measurements`, data)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err))
    })
  },

  postPatientAppointment(data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/appointments`, data)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err))
    })
  },

  getReportData(patientId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/patients/${patientId}/checkup-plus/report`)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err))
    })
  }
}
